/**
 * 🤖 AUTO-GENERATED API SCHEMA FILE - DO NOT EDIT DIRECTLY!
 *
 * This file is automatically generated from entity configuration files.
 * Any manual changes will be lost when the generator runs again.
 *
 * 🔄 DATA FLOW PIPELINE:
 * 1. Entity Config (config/entities/field_change_suggestions-entity-config.ts) → Single Source of Truth
 * 2. THIS FILE → TypeBox schemas for runtime validation + API types
 * 3. API Clients → Use these schemas for request/response validation
 * 4. React Hooks → Use these types for type-safe data fetching
 * 5. Components → Import types from this schema file
 *
 * 🛠️ TO MODIFY:
 * - Edit the entity config file: config/entities/field_change_suggestions-entity-config.ts
 * - Run: npm run schemas:gen (regenerates this file)
 *
 * 📋 ARCHITECTURE:
 * - Entity configs define field publicity, types, and validation rules
 * - TypeBox schemas provide runtime validation for API requests/responses
 * - Static types are derived from TypeBox schemas for compile-time safety
 * - Query options and response types standardize API interactions
 *
 * 🔗 RELATED FILES:
 * - config/entities/field_change_suggestions-entity-config.ts (source configuration)
 * - scripts/generate-api-clients.ts (this generator)
 * - client/api/generated_clients/generated-field_change_suggestions-api-client.ts (API client using these schemas)
 * - client/api/generated_hooks/field_change_suggestions.ts (React hooks using these types)
 *
 * 🔒 SECURITY: Only fields marked as 'public: true' in the config are included
 *
 * Source config: config/entities/field_change_suggestions-entity-config.ts
 * Public fields: 15/15 total fields
 */

import { Type, Static } from '@sinclair/typebox';


// TypeBox schemas for runtime validation (public fields only)
export const FieldChangeSuggestionsSchema = Type.Object({
  id: Type.String({ format: "uuid" }), // id field
  target_table: Type.String(), // target_table field
  target_record_id: Type.String({ format: "uuid" }), // target_record_id field
  field_name: Type.String(), // field_name field
  current_value_snapshot: Type.Union([Type.String(), Type.Null()]), // current_value_snapshot field
  suggested_value: Type.String(), // suggested_value field
  note: Type.Union([Type.String(), Type.Null()]), // note field
  suggested_by_user_profile_id: Type.String({ format: "uuid" }), // suggested_by_user_profile_id field
  suggested_at: Type.String({ format: "date-time" }), // suggested_at field
  status: Type.Any(), // status field
  reviewed_by_user_profile_id: Type.Union([Type.String({ format: "uuid" }), Type.Null()]), // reviewed_by_user_profile_id field
  reviewed_at: Type.Union([Type.String({ format: "date-time" }), Type.Null()]), // reviewed_at field
  decision_note: Type.Union([Type.String(), Type.Null()]), // decision_note field
  is_junction: Type.Boolean(), // is_junction field
  updated_at: Type.String({ format: "date-time" }), // updated_at field
});

export const CreateFieldChangeSuggestionsSchema = Type.Object({
  target_table: Type.String(), // target_table field
  target_record_id: Type.String({ format: "uuid" }), // target_record_id field
  field_name: Type.String(), // field_name field
  current_value_snapshot: Type.Optional(Type.Union([Type.String(), Type.Null()])), // current_value_snapshot field
  suggested_value: Type.String(), // suggested_value field
  note: Type.Optional(Type.Union([Type.String(), Type.Null()])), // note field
  suggested_by_user_profile_id: Type.String({ format: "uuid" }), // suggested_by_user_profile_id field
  suggested_at: Type.Optional(Type.String({ format: "date-time" })), // suggested_at field
  status: Type.Optional(Type.Any()), // status field
  reviewed_by_user_profile_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // reviewed_by_user_profile_id field
  reviewed_at: Type.Optional(Type.Union([Type.String({ format: "date-time" }), Type.Null()])), // reviewed_at field
  decision_note: Type.Optional(Type.Union([Type.String(), Type.Null()])), // decision_note field
  is_junction: Type.Optional(Type.Boolean()), // is_junction field
});

export const UpdateFieldChangeSuggestionsSchema = Type.Object({
  target_table: Type.Optional(Type.String()), // target_table field
  target_record_id: Type.Optional(Type.String({ format: "uuid" })), // target_record_id field
  field_name: Type.Optional(Type.String()), // field_name field
  current_value_snapshot: Type.Optional(Type.Union([Type.String(), Type.Null()])), // current_value_snapshot field
  suggested_value: Type.Optional(Type.String()), // suggested_value field
  note: Type.Optional(Type.Union([Type.String(), Type.Null()])), // note field
  suggested_by_user_profile_id: Type.Optional(Type.String({ format: "uuid" })), // suggested_by_user_profile_id field
  suggested_at: Type.Optional(Type.String({ format: "date-time" })), // suggested_at field
  status: Type.Optional(Type.Any()), // status field
  reviewed_by_user_profile_id: Type.Optional(Type.Union([Type.String({ format: "uuid" }), Type.Null()])), // reviewed_by_user_profile_id field
  reviewed_at: Type.Optional(Type.Union([Type.String({ format: "date-time" }), Type.Null()])), // reviewed_at field
  decision_note: Type.Optional(Type.Union([Type.String(), Type.Null()])), // decision_note field
  is_junction: Type.Optional(Type.Boolean()), // is_junction field
});

// TypeScript types derived from TypeBox schemas (matching server-side pattern)
export type FieldChangeSuggestionsRow = Static<typeof FieldChangeSuggestionsSchema>;
export type FieldChangeSuggestionsInsert = Static<typeof CreateFieldChangeSuggestionsSchema>;
export type FieldChangeSuggestionsUpdate = Static<typeof UpdateFieldChangeSuggestionsSchema>;

// Legacy type aliases for backward compatibility
export type FieldChangeSuggestions = FieldChangeSuggestionsRow;
export type CreateFieldChangeSuggestions = FieldChangeSuggestionsInsert;
export type UpdateFieldChangeSuggestions = Static<typeof UpdateFieldChangeSuggestionsSchema>;

// Field configuration metadata
export const FieldChangeSuggestionsFieldConfig = {
  filterable: ['id', 'target_record_id', 'suggested_by_user_profile_id', 'status', 'reviewed_by_user_profile_id'] as const,
  sortable: ['updated_at'] as const,
  searchable: [] as const,
  required: ['id', 'target_table', 'target_record_id', 'field_name', 'suggested_value', 'suggested_by_user_profile_id', 'suggested_at', 'status', 'is_junction', 'updated_at'] as const,
  readonly: ['id', 'updated_at'] as const,
} as const;

// Query options interface for API operations
import type { UnifiedQueryOptions } from '../../config/search/global-search-config.js';

export interface FieldChangeSuggestionsQueryOptions extends UnifiedQueryOptions {}

// Response types for API operations
export interface FieldChangeSuggestionsResponse {
  data: FieldChangeSuggestions[] | null;
  error: Error | null;
  count?: number;
}

export interface SingleFieldChangeSuggestionsResponse {
  data: FieldChangeSuggestions | null;
  error: Error | null;
}
